(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvButtonAdd', drvButtonAdd);

    drvButtonAdd.$inject = [];
    
    /**
     * An 'add' button.
     */
    function drvButtonAdd() {
        var directive = {
            restrict: 'E',
            scope: {
                ngClick: '&?',
                ariaLabel: '@?'
            },
            template: '<md-button title="{{ariaLabel}}" class="md-icon-button md-accent" ng-click="ngClick" aria-label="{{ariaLabel}}"><drv-icon usage="\'add\'"></drv-icon></md-button>'
        };
        return directive;
    }
})();